import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

const map = require('lodash/map');
const find = require('lodash.find');

import { IGeoObject } from '../../components/search_filters/filters/geo_suggest/geo_helpers';
import {
  isNewbuildingsSuggestEnabledForBuildingType,
  isNewbuildingsSuggestEnabledForSearchType,
  isNewbuildingsSuggestEnabledForSection,
} from '../../components/search_filters/filters/geo_suggest/suggests_helpers';
import { UserGeoFilter as UserGeoFilterInput } from '../../components/search_filters/filters/user_geo_filter';
import { UserGeoMultiFilter } from '../../components/search_filters/filters/user_geo_multi_filter';
import { UserGeoStrictFilter } from '../../components/search_filters/filters/user_geo_strict_filter';
import { getNewbuildingsGeosuggestEnabled } from '../../helpers/ab_mainpage_newbuilding_search';
import * as Analytics from '../../helpers/analytics_helper';
import { getCookie } from '../../helpers/cookie_helper';
import { getAddressSuggestions, getMultiSuggest } from '../../helpers/geo_suggest';
import { INewbuildingSuggestion } from '../../helpers/newbuildings_geo_suggest';
import { getNewbuildingsSearchSuggestions } from '../../helpers/newbuildings_geo_suggest';
import { getMainPlaceholder } from '../../helpers/placeholder';
import { IUserGeo, IUserGeoDefinitionWithFilter, IUserGeoSearch } from '../../models/filters/user_geo';
import { IRegionsData } from '../../models/regions_data';
import { IStore } from '../../models/store';
import { IDomain } from '../../redux/modules/domain/domain';
import { selectSuburbanBuildingType } from '../../redux/modules/search/building_types';
import { ISetUserGeoWithGeoType, selectGeo, setUserGeoSuggest } from '../../redux/modules/search/user_geo';
import {
  ISetDirty,
  ISetUserGeo,
  setDirty,
  setUserGeo,
  setUserGeoWithGeoType,
} from '../../redux/modules/search/user_geo';

interface IStateProps {
  buildingType: string;
  searchType: string;
  userGeo: IUserGeo;
  regionsData: IRegionsData;
  domain: IDomain;
  section: string;
  isNewbuildingsGeosuggestEnabled: boolean;
  countrysideSuggestEnabled: boolean;
}

interface IDispatchProps {
  setDirty: ISetDirty;
  setUserGeo: ISetUserGeo;
  setUserGeoWithGeoType: ISetUserGeoWithGeoType;
  setGeoSuggest(geoSuggest: string): void;
  onGeoSelected(value: IGeoObject, countrysideSuggestEnabled?: boolean): void;
  getNewbuildingsSearchSuggestions(text: string, region: number | undefined): Promise<INewbuildingSuggestion[]>;
}

interface IOwnProps {}

interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

interface IRegionAndCity {
  id: number;
  title: string;
  subdomainName?: string;
}

interface IFormatedRegionAndCity {
  value: number;
  label: string;
}

enum EFavoritesNewBuildinsRegions {
  MoscowAndMO = 1,
  SPBAndLO = 2,
}

const STRICT_GEO_VERTICALS = [
  'index',
  'sale',
  'rent',
];

class UserGeoFilter extends Component<IProps, {}> {
  protected setDirty(isDirty: boolean) {
    this.props.setDirty(isDirty);
  }

  private getGeoCookie(query: string): string {
    if (typeof window !== 'undefined') {
      return getCookie(document.cookie, query);
    }

    return '';
  }

  public componentWillMount() {
    this.setDirty(false);

    const geoIDSessionMainTown = Number(this.getGeoCookie('session_main_town_region_id'));
    const geoIDSessionRegion = Number(this.getGeoCookie('session_region_id'));
    const geoIDForeverMainTown = Number(this.getGeoCookie('forever_main_town_region_id'));
    const geoIDForeverRegion = Number(this.getGeoCookie('forever_region_id'));

    let geoID: number | undefined;

    if (this.props.section !== 'new-buildings') {
      geoID = geoIDSessionMainTown
        || geoIDSessionRegion
        || geoIDForeverMainTown
        || geoIDForeverRegion;
    }

    if (!geoID) {
      geoID = find(
        this.props.regionsData.regions,
        [ 'id', this.props.userGeo.userGeo ]) ? this.props.userGeo.userGeo : 1;
    }

    if (this.props.section === 'new-buildings') {
      switch (geoID) {
        case EFavoritesNewBuildinsRegions.MoscowAndMO:
          geoID = -1 * EFavoritesNewBuildinsRegions.MoscowAndMO;
          break;

        case EFavoritesNewBuildinsRegions.SPBAndLO:
          geoID = -1 * EFavoritesNewBuildinsRegions.SPBAndLO;
          break;

        default:
          break;
      }
    }

    this.props.setUserGeo(geoID);
  }

  public componentDidMount() {
    this.setDirty(true);
  }

  public render() {
    const {
      section,
      userGeo,
      regionsData: { regions, cities },
      getNewbuildingsSearchSuggestions,
      setUserGeo,
      isNewbuildingsGeosuggestEnabled,
      buildingType,
      searchType,
      onGeoSelected,
      countrysideSuggestEnabled,
    } = this.props;

    const isNewbuildingsGeosuggestActive =
      isNewbuildingsGeosuggestEnabled &&
      isNewbuildingsSuggestEnabledForSection(section) &&
      isNewbuildingsSuggestEnabledForSearchType(searchType) &&
      isNewbuildingsSuggestEnabledForBuildingType(buildingType)
    ;

    const placeholder = getMainPlaceholder(buildingType);

    if (section !== 'new-buildings') {
      return  (
        <UserGeoMultiFilter
          bsCenterId={userGeo.bsCenterId}
          buildingType={buildingType}
          searchType={searchType}
          section={section}
          getMultiSuggest={getMultiSuggest}
          regionOrMaintownId={userGeo.userGeo}
          geoValue={userGeo.geoValue}
          regions={this.formatData(regions)}
          cities={this.formatData(cities)}
          setUserGeo={setUserGeo}
          text={userGeo.text}
          onChange={this.onGeoStrictFilterChanged}
          onGeoSuggestChange={this.onGeoSuggestChange}
          onGeoSelected={onGeoSelected}
          placeholder={placeholder}
          countrysideSuggestEnabled={countrysideSuggestEnabled}
        />
      );
    } else if (STRICT_GEO_VERTICALS.includes(section)) {
      return (
        <UserGeoStrictFilter
          section={section}
          regionOrMaintownId={userGeo.userGeo}
          geoValue={userGeo.geoValue}
          regions={this.formatData(regions)}
          cities={this.formatData(cities)}
          onChange={this.onGeoStrictFilterChanged}
          onGeoSuggestChange={this.onGeoSuggestChange}
          onGeoSelected={onGeoSelected}
          getAddressSuggestions={getAddressSuggestions}
          getNewbuildingsSearchSuggestions={getNewbuildingsSearchSuggestions}
          isNewbuildingsGeosuggestActive={isNewbuildingsGeosuggestActive}
        />
      );
    } else {
      return (
        <UserGeoFilterInput
          section={section}
          value={userGeo.userGeo}
          values={this.formatData(regions)}
          cities={this.formatData(cities)}
          onChange={(geo: number) => {
            Analytics.changeGeoSuggest(section, geo);
            setUserGeo(geo);
          }}
        />
      );
    }

  }

  private onGeoStrictFilterChanged = (
    userGeoDefinitionWithFilter: IUserGeoDefinitionWithFilter,
    userGeoSearch: IUserGeoSearch,
  ): void => {
    this.props.setUserGeoWithGeoType(userGeoDefinitionWithFilter, userGeoSearch);
  }

  private onGeoSuggestChange = (geoSuggest: string) => {
    this.props.setGeoSuggest(geoSuggest);
  }

  private formatData(data: IRegionAndCity[]): IFormatedRegionAndCity[] {
    return map(data, (item: any) => {
      return {
        label: item.title,
        value: item.id,
      };
    });
  }
}

function mapStateToProps(state: IStore, props: IOwnProps): IStateProps {
  const { mainpage, domain, userGeo, buildingType, type } = state;
  const {
    section,
    regionsData,
    experiments = [],
  } = mainpage;

  return {
    buildingType: buildingType.buildingType[0],
    domain,
    isNewbuildingsGeosuggestEnabled: getNewbuildingsGeosuggestEnabled(mainpage),
    regionsData,
    searchType: type.searchType,
    section,
    userGeo,
    countrysideSuggestEnabled: experiments.some(({ name, abGroup }) => {
      return name === 'countryside_orthodox_parish' && abGroup === 1;
    }) && buildingType.featureToggleCountrysideOrthodoxParish === 'enabled',
  };
}

function mapDispatchToProps(dispatch: Dispatch, props: IOwnProps): IDispatchProps {
  return {
    getNewbuildingsSearchSuggestions: (text: string, region: number | undefined) =>
      dispatch(getNewbuildingsSearchSuggestions(text, region) as any),
    onGeoSelected: (value: IGeoObject, countrysideSuggestEnabled?: boolean) => {
      if (value.type === 'village' && countrysideSuggestEnabled) {
        dispatch(selectSuburbanBuildingType(value.id) as any);
      }
      dispatch(selectGeo(value));
    },
    setDirty: (isDirty: boolean) => dispatch(setDirty(isDirty)),
    setUserGeo: (userGeo: number) => dispatch(setUserGeo(userGeo)),
    setGeoSuggest: ((geoSuggest: string) => dispatch(setUserGeoSuggest(geoSuggest))),
    setUserGeoWithGeoType: (
      userGeoDefinitionWithGeoFilter: IUserGeoDefinitionWithFilter,
      userGeoSearch: IUserGeoSearch,
    ) => dispatch(setUserGeoWithGeoType(userGeoDefinitionWithGeoFilter, userGeoSearch)),
  };
}

const UserGeoFilterWrapper = connect<
  IStateProps, IDispatchProps, IOwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(UserGeoFilter);

export { UserGeoFilterWrapper as UserGeoFilter, UserGeoFilter as UserGeoFilterClass };
